import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "rangePreset", "groupCheckbox", "allButton"]

  connect() {
    this.refreshRangePresets()
    this.refreshAllButtons()
  }

  setRange(event) {
    event.preventDefault()
    const preset = event.currentTarget.dataset.reportFiltersRangeParam
    const today = new Date()
    let start = ""
    let end = ""

    if (preset === "year") {
      start = this.formatDate(new Date(today.getFullYear(), 0, 1))
      end   = this.formatDate(new Date(today.getFullYear(), 11, 31))
    } else if (preset === "month") {
      start = this.formatDate(new Date(today.getFullYear(), today.getMonth(), 1))
      end   = this.formatDate(new Date(today.getFullYear(), today.getMonth() + 1, 0))
    }

    if (this.hasStartDateTarget) this.startDateTarget.value = start
    if (this.hasEndDateTarget)   this.endDateTarget.value   = end

    this.refreshRangePresets()
  }

  onDateChange() {
    this.refreshRangePresets()
  }

  toggleAll(event) {
    event.preventDefault()
    const group = event.currentTarget.dataset.reportFiltersGroupParam
    const boxes = this.groupCheckboxTargets.filter(cb => cb.dataset.reportFiltersGroupParam === group)
    if (boxes.length === 0) return

    const allChecked = boxes.every(cb => cb.checked)
    boxes.forEach(cb => { cb.checked = !allChecked })
    this.refreshAllButtons()
  }

  onCheckboxChange() {
    this.refreshAllButtons()
  }

  refreshRangePresets() {
    if (!this.hasRangePresetTarget) return
    const start = this.hasStartDateTarget ? this.startDateTarget.value : ""
    const end   = this.hasEndDateTarget   ? this.endDateTarget.value   : ""
    const active = this.detectActivePreset(start, end)

    this.rangePresetTargets.forEach(button => {
      const preset = button.dataset.reportFiltersRangeParam
      button.classList.toggle("purple-btn", preset === active)
      button.classList.toggle("purple-outline-btn", preset !== active)
    })
  }

  refreshAllButtons() {
    if (!this.hasAllButtonTarget) return
    this.allButtonTargets.forEach(button => {
      const group = button.dataset.reportFiltersGroupParam
      const boxes = this.groupCheckboxTargets.filter(cb => cb.dataset.reportFiltersGroupParam === group)
      if (boxes.length === 0) return
      const allChecked = boxes.every(cb => cb.checked)
      const noneChecked = boxes.every(cb => !cb.checked)
      const showAsAll = allChecked || noneChecked
      button.classList.toggle("purple-btn", showAsAll)
      button.classList.toggle("purple-outline-btn", !showAsAll)
    })
  }

  detectActivePreset(start, end) {
    if (!start && !end) return "all"
    const today = new Date()
    const yearStart  = this.formatDate(new Date(today.getFullYear(), 0, 1))
    const yearEnd    = this.formatDate(new Date(today.getFullYear(), 11, 31))
    const monthStart = this.formatDate(new Date(today.getFullYear(), today.getMonth(), 1))
    const monthEnd   = this.formatDate(new Date(today.getFullYear(), today.getMonth() + 1, 0))

    if (start === yearStart  && end === yearEnd)  return "year"
    if (start === monthStart && end === monthEnd) return "month"
    return null
  }

  formatDate(date) {
    const yyyy = date.getFullYear()
    const mm   = String(date.getMonth() + 1).padStart(2, "0")
    const dd   = String(date.getDate()).padStart(2, "0")
    return `${yyyy}-${mm}-${dd}`
  }
}
